import type { ModelVersionWorkflowStatus } from "../_types/content-models.types";

/** Title-case words for species display names from the catalog. */
export function formatSpeciesDisplayName(name: string): string {
  const t = name.trim();
  if (!t) return name;
  return t
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => {
      if (!w.length) return "";
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    })
    .join(" ");
}

/** Human-readable label for a workflow status value from the API / DB. */
export function workflowStatusToDisplayLabel(status: string): string {
  const key = status.trim().toLowerCase();
  const known: Record<string, string> = {
    active: "Active",
    superseded: "Superseded",
    in_review: "In review",
    draft: "Draft",
    processing: "Processing",
  };
  if (known[key]) return known[key];
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

/** Badge style for a catalog / version status string (same as DB). */
export function getCatalogStatusBadgeMeta(status: string): {
  label: string;
  variant: "primary" | "secondary" | "success" | "warning" | "danger";
} {
  const key = status.trim().toLowerCase();
  let variant: "primary" | "secondary" | "success" | "warning" | "danger" =
    "secondary";
  switch (key) {
    case "active":
      variant = "success";
      break;
    case "superseded":
      variant = "secondary";
      break;
    case "in_review":
      variant = "warning";
      break;
    case "draft":
      variant = "secondary";
      break;
    case "processing":
      variant = "primary";
      break;
    default:
      variant = "secondary";
  }
  return { label: workflowStatusToDisplayLabel(status), variant };
}

export function getLibraryStatusMeta(status: string) {
  return getCatalogStatusBadgeMeta(status);
}

export function getVersionStatusMeta(status: ModelVersionWorkflowStatus) {
  return getCatalogStatusBadgeMeta(status);
}
